import { render, staticRenderFns } from "./dy-dialog.vue?vue&type=template&id=335de9fc"
import script from "./dy-dialog.vue?vue&type=script&lang=js"
export * from "./dy-dialog.vue?vue&type=script&lang=js"
import style0 from "./dy-dialog.vue?vue&type=style&index=0&id=335de9fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports